/**
 * "Last checked", and a warning when oddits and the portal disagree — for one
 * return and one period, wherever a filing status is shown.
 * @file src/web/features/admin/components/PortalTrustNote.tsx
 */
import { AlertTriangle } from 'lucide-react';
import { freshness, disagreement, type PortalEntry } from '../lib/portal-status';
import type { FilingStatusRow } from '../lib/filing-status';

export function PortalTrustNote({ rows, entry, now }: {
  rows: (FilingStatusRow & { arn: string | null })[]; entry?: PortalEntry; now?: Date;
}) {
  const at = now ?? new Date();
  const checked = freshness(entry?.checkedAt, at);
  const warning = disagreement(rows, entry, at);
  return (
    <div className="space-y-1.5">
      <p className={`text-[11px] ${checked.state === 'fresh' ? 'text-ink-500' : 'text-warn-700'}`} data-freshness={checked.state}>{checked.text}</p>
      {warning && (
        <p role="alert" className="flex items-start gap-1.5 rounded-lg border border-warn-200 bg-warn-50 px-2.5 py-1.5 text-[11px] font-medium text-warn-800">
          <AlertTriangle className="mt-px h-3 w-3 shrink-0" />{warning}
        </p>
      )}
    </div>
  );
}
